/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */

// TODO: fix all the eslint issues with this file

import { type FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

export function errorDetail(error?: FetchBaseQueryError): string | undefined {
  if (!error) {
    return undefined;
  }

  if (typeof error.status !== "number") {
    return undefined;
  }

  const data = error.data as any;
  const detail = data?.detail;

  // if detail is a string, return it
  if (typeof detail === "string") {
    return detail;
  }

  // if detail is an array of validation errors, extract the first message
  if (Array.isArray(detail) && detail.length > 0) {
    const firstError = detail[0];
    if (firstError?.msg && typeof firstError.msg === "string") {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return firstError.msg;
    }
  }

  return undefined;
}

type FieldError = {
  field: string;
  message: string;
};

/**
 * Extracts field validation errors from an API error response.
 * Returns an array of field errors with their messages.
 * Useful for setting form field errors with react-hook-form.
 */
export function extractFieldErrors(error: unknown): FieldError[] {
  const fieldErrors: FieldError[] = [];
  const apiError = error as any;

  if (apiError?.data?.detail && Array.isArray(apiError.data.detail)) {
    apiError.data.detail.forEach((err: any) => {
      if (err.loc && err.msg && Array.isArray(err.loc) && err.loc.length > 0) {
        // Use the last element of loc array as it contains the actual field name
        // (loc might be ['body', 'field_name'] for body parameters)
        const field = err.loc[err.loc.length - 1];
        fieldErrors.push({ field, message: err.msg });
      }
    });
  }

  return fieldErrors;
}
